// muiのtableをnitoelで使うようにwrap(style当ててるだけ)

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import { ReactNode } from "react";

export const NitoelTable = styled(Table)({});

// V2を使う場合には、NitoelTableContainerを適用すること(=コンテンツがはみ出す時、横スクロールしてくれるようになる)
export const NitoelTableContainer = styled(TableContainer)({});

export const NitoelTHead = styled(TableHead)({ borderBottom: "2px solid" });

export const NitoelTBody = styled(TableBody)({});

export const NitoelTRow = styled(TableRow)({});

// TODO: V2とV1の統合(方針はBodyCellと同じ)
export const NitoelTHeaderCell = styled(TableCell)({
  fontWeight: "bold",
});

export const NitoelTHeaderCellV2 = styled(TableCell)({
  fontWeight: "bold",
  // headerに連続スペースとか想定されないと思うのでpreにしておく
  whiteSpace: "pre",
});

// TODO: V2とV1の統合
//   違いは下に書いた通り、横スクロースを前提としたTableに使われているかどうか、という差違でしかない。
// 基本的な対応方針としては、全TableにScrollをつけて(=NitoelTableContainerを適用する)、whiteSpace: preをデフォルトとし、一部空白を無視したいcellについては個別にnoWrapを指定するような形の運用が望ましいと思われる。

// ・part.nameに連続スペースが含まれている際に正しく表示がされないなど問題が発生しうるので、whiteSpace: pre-wrapを設定しておく。
//   もし問題あるケースありそうならば、対応する。
// ・pre-wrapだとhtmlの幅でよしなに折り返してしまう。ただスクロールがついていない画面だとこうしておかないと文字がhtmlをつきぬけていってしまう(preだとそうなる)。
//   こちらのcomponentを使う箇所はスクロールがついてる画面のほうが(まだ)少数派かとおもうので、pre-wrapをデフォルトとする。
// ・noWrapは連続スペースを圧縮してしまい、コンテンツが変わってしまうのでできる限り利用しない
export const NitoelTBodyCell = styled(TableCell)({
  whiteSpace: "pre-wrap",
});

export const NitoelTBodyCellV2 = styled(TableCell)({
  // こちらのComponentが生まれた時に、横スクロールを前提とするNitoelTableContainerが生み出され、基本そちらとセットで使われているはずなので、V1とは違いこちらはpreがデフォで良い。noWrapはやはり、できる限り避けておく。
  whiteSpace: "pre",
});

export const NitoelLabelCell = styled(TableCell)`
  &.required::after {
    content: " *";
    color: red;
  }
  background-color: #e8f4ff;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
  white-space: nowrap;
`;

export const NitoelValueCell = styled(TableCell)`
  border-right: 1px solid #ccc;
  white-space: pre-wrap;
`;

const LayoutFixedTable = styled(Table)({ border: "1px solid", borderColor: "#d3d3d3", tableLayout: "fixed" });

export const NitoelLayoutFixedTable = ({ children }: { children: ReactNode }) => {
  return <LayoutFixedTable size="small">{children}</LayoutFixedTable>;
};
